import { useEffect, useState } from 'react'
import { getVendors } from '../../api/master'

// Helpers shared by the Purchase pages.

const key = (v) => String(v || '').trim().toLowerCase().replace(/[\s_-]/g, '')

/** A purchase order's state in plain words: approval first, then delivery. */
export function poState(row) {
  const approval = key(row?.approval_status)
  const status = key(row?.status)
  if (approval === 'pending') return { id: 'approval', label: 'Waiting for approval', tone: 'warn' }
  if (approval === 'rejected') return { id: 'rejected', label: 'Rejected', tone: 'bad' }
  if (status.includes('closed') || status.includes('cancel')) return { id: 'closed', label: 'Closed', tone: 'muted' }
  if (status === 'received' || status.includes('fulfilled')) return { id: 'received', label: 'Received', tone: 'good' }
  if (status.includes('partially')) return { id: 'ordered', label: 'Part received', tone: 'info' }
  return { id: 'ordered', label: 'Waiting for goods', tone: 'info' }
}

/** Where a vendor invoice is in the Purchasing -> Accounting -> paid flow. */
const INVOICE_STATES = {
  draft: { group: 'yours', label: 'Draft', tone: 'muted' },
  returnedtopurchasing: { group: 'yours', label: 'Sent back to you', tone: 'warn' },
  submitted: { group: 'accounting', label: 'With Accounting', tone: 'info' },
  matched: { group: 'accounting', label: 'Checked by Accounting', tone: 'info' },
  matchexception: { group: 'accounting', label: "Doesn't match the PO", tone: 'warn' },
  approved: { group: 'accounting', label: 'Approved', tone: 'info' },
  postedtoap: { group: 'unpaid', label: 'To be paid', tone: 'info' },
  partiallypaid: { group: 'unpaid', label: 'Part paid', tone: 'info' },
  paid: { group: 'paid', label: 'Paid', tone: 'good' },
  rejected: { group: 'closed', label: 'Rejected', tone: 'bad' },
  voided: { group: 'closed', label: 'Void', tone: 'bad' },
}

export const invoiceState = (row) => INVOICE_STATES[key(row?.status)] || { group: 'yours', label: row?.status || 'Draft', tone: 'muted' }

/** vendor_id -> name, for lists whose rows only carry the id. */
export function useVendorNames() {
  const [names, setNames] = useState({})
  useEffect(() => {
    getVendors()
      .then((vs) => setNames(Object.fromEntries((vs || []).map((v) => [String(v.vendor_id), v.name]))))
      .catch(() => {})
  }, [])
  return names
}

/** "Mama Gold Rice 50kg · RICE-50" for product pickers. */
export const productLabel = (p) => [p?.name, p?.sku].filter(Boolean).join(' · ') || `Product #${p?.product_id}`
